import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { GameContext, UseGame } from '../providers/GameProvider';

const useGame = <T>(): UseGame<T> => {
  const [state, dispatch] = useContextWithErrorHandler(GameContext, 'GameProvider');

  return [state, dispatch];
};

export default useGame;
